import { Component, Injector, OnInit, inject, ChangeDetectionStrategy, signal } from '@angular/core';
import { jkBaseForm, jkGlb, TitlebarComponent, MaterialModule, JackBaseComponentModule } from 'jk-service';
import { MdqSearchComponent } from '../components/md-query/mdq-search.component';

@Component({
  standalone: true,
  selector: 'app-utyjb53',
  templateUrl: './utyjb53.component.html',
  styleUrls: ['./utyjb53.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MaterialModule, JackBaseComponentModule, TitlebarComponent, MdqSearchComponent],
})
export class Utyjb53Component extends jkBaseForm implements OnInit {
  override _programId = 'utyjb53';
  get backendUrl(): string {
    return jkGlb.config?.mdQueryUrl || this._backendUrl;
  }
  set backendUrl(value: string) {
    this._backendUrl = value;
  }
  private _backendUrl: string = '';
  mdQueryToken = signal('');
  constructor(injector: Injector = inject(Injector)) {
    super(injector);
    if (jkGlb.config?.mdQueryUrl) {
      this.backendUrl = jkGlb.config.mdQueryUrl;
    }
    if (jkGlb.config?.mdQueryToken) {
      this.mdQueryToken.set(jkGlb.config.mdQueryToken);
    }
  }

  override ngOnInit() {
    super.ngOnInit();
    if (!this.backendUrl && jkGlb.config?.mdQueryUrl) {
      this.backendUrl = jkGlb.config.mdQueryUrl;
    }
  }

  override async ngAfterViewInit() {
    await super.ngAfterViewInit();
    this.checkAllInit(this);
    if (!this.backendUrl && jkGlb.config?.mdQueryUrl) {
      this.backendUrl = jkGlb.config.mdQueryUrl;
    }
  }
}

